import React, { useState, useEffect } from 'react';
import { FormularioRespostasModal } from '@components/Modals/Shared/FormularioRespostasModal/Index';
import { useDispatch, useSelector } from 'react-redux';
import { carregarFormularioRespostaItemProcesso } from '@store/slices/formularios/ItemProcesso/formularioRespostaItemProcessoSlice';
import { makeSelectFormularioRespostaByItemId } from '@store/selectors/formularios/ItemProcesso/formularioRespostaItemProcessoSelector';
import CustomAntdModal from '@components/Modals/Shared/CustomAntdModal/Index';
import ButtonComp from '@components/UI/Button/Index';
import SweetAlert from '@components/Feedback/SweetAlert/Index';
import { FormularioResponderItemProcessoModal } from '../FormularioResponderItemProcessoModal/Index';
import { perfisVisitante } from '@utils/auth/perfis';
import { useAppAuth } from '@contexts/AuthContext';

export const FormularioOptionItemProcessoModal = ({
    idFormularioAssociado,
    idSolicitacaoProcessoItem,
    idSolicitacao,
    formularioRespostaInicial,
}) => {
    const dispatch = useDispatch();
    const selectResposta = makeSelectFormularioRespostaByItemId(idSolicitacaoProcessoItem);
    const formularioResposta = useSelector(selectResposta);

    // Carrega resposta inicial apenas no primeiro load
    useEffect(() => {
        if (!formularioResposta && formularioRespostaInicial) {
            dispatch(
                carregarFormularioRespostaItemProcesso({ idProcessoItem: idSolicitacaoProcessoItem, resposta: formularioRespostaInicial })
            );
        }
    }, [formularioResposta, formularioRespostaInicial, idSolicitacaoProcessoItem, dispatch]);

    const { role } = useAppAuth();
    const isVisitante = perfisVisitante.includes(role);

    const formularioJaRespondido = Boolean(
        formularioResposta?.formularioJson && formularioResposta?.respostaJson
    );
    const idFormularioResposta = formularioResposta?.id;

    const [optionsModalOpen, setOptionsModalOpen] = useState(false);
    const [responderVisible, setResponderVisible] = useState(false);
    const [respostasVisible, setRespostasVisible] = useState(false);

    const handleClick = () => {
        if (!idFormularioAssociado) {
            SweetAlert.toastError('Nenhum formulário de item de processo associado.');
            return;
        }

        if (isVisitante) {
            if (formularioJaRespondido) {
                setRespostasVisible(true);
            } else {
                SweetAlert.toastInfo('Seu perfil (Visitante) não tem permissão para responder formulários.');
            }
            return;
        }

        setOptionsModalOpen(true);
    };

    const getTooltipText = () => {
        return formularioJaRespondido ? 'Formulário Respondido' : 'Formulário Pendente';
    };

    return (
        <div>
            <div className="d-flex justify-content-center gap-2">
                <i
                    className="fa-regular fa-clipboard fs-6"
                    style={{ color: idFormularioAssociado ? '#125578' : '#ccc', cursor: idFormularioAssociado ? 'pointer' : 'not-allowed' }}
                    title={idFormularioAssociado ? getTooltipText() : 'Nenhum formulário disponível'}
                    onClick={handleClick}
                />
                {idFormularioAssociado && (
                    <i
                        className={`fa-solid ${formularioJaRespondido ? 'fa-check text-success' : 'fa-minus text-muted'
                            } fs-6`}
                        style={{ opacity: 0.7, cursor: 'default' }}
                        title={getTooltipText()}
                    />
                )}
            </div>

            <CustomAntdModal
                open={optionsModalOpen}
                onCancel={() => setOptionsModalOpen(false)}
                title="Formulário disponível"
                description="Selecione uma das opções abaixo:"
            >
                {!formularioJaRespondido && (
                    <ButtonComp
                        title="Responder"
                        buttonColor="#125578"
                        type="button"
                        classnameIcon="fa-regular fa-edit"
                        hoverMessage="Responder formulário"
                        style={{ width: '100%' }}
                        onClick={() => { setResponderVisible(true); setOptionsModalOpen(false); }}
                    />
                )}
                {formularioJaRespondido && (
                    <ButtonComp
                        title="Visualizar Respostas"
                        buttonColor="#2b97be"
                        type="button"
                        classnameIcon="fa-regular fa-eye"
                        //hoverMessage="Visualizar respostas"
                        style={{ width: '100%' }}
                        onClick={() => { setRespostasVisible(true); setOptionsModalOpen(false); }}
                    />
                )}
                <ButtonComp
                    title="Cancelar"
                    buttonColor="#dc3545"
                    type="button"
                    classnameIcon="fa-solid fa-xmark"
                    style={{ width: '100%' }}
                    //hoverMessage="Cancelar"
                    onClick={() => setOptionsModalOpen(false)}
                />
            </CustomAntdModal>

            <FormularioResponderItemProcessoModal
                visible={responderVisible}
                onClose={() => setResponderVisible(false)}
                idFormularioAssociado={idFormularioAssociado}
                idSolicitacao={idSolicitacao}
                idSolicitacaoProcessoItem={idSolicitacaoProcessoItem}
            />

            <FormularioRespostasModal
                visible={respostasVisible}
                onClose={() => setRespostasVisible(false)}
                formularioId={idFormularioResposta}
                idSolicitacao={idSolicitacao}
            />
        </div>
    );
};